
import "./styles.scss"

function SectionSpacer() {
    return(
        <div className="tw-pb-[100px] lg:tw-pb-[140px]">
    
        </div>
    )
}

export default SectionSpacer